import { Config as ConfigType } from './types';
import { user } from './eliot/user';
import { expert } from './eliot/expert';
import { client } from './eliot/client';
import { company } from './eliot/company';
import { purchaseOrder } from './eliot/purchaseOrder';
import { validationOrder } from './eliot/validationOrder';
import { mission } from './eliot/mission';
import { invitation } from './eliot/invitation';
import { candidate } from './eliot/candidate';
import { candidacy } from './eliot/candidacy';
import { proposal } from './eliot/proposal';
import { quotation } from './eliot/quotation';
import { charge } from './eliot/charge';
import { milestone } from './eliot/milestone';
import { contract } from './eliot/contract';
import { contractMilestone } from './eliot/contractMilestone';
import { invoice } from './eliot/invoice';
import { recommendation } from './eliot/recommendation';
import { legalInformation } from './eliot/legalInformation';
import { cgu } from './eliot/cgu';
import { match } from './eliot/match';
import { document } from './eliot/document';
import { subCategory } from './eliot/subCategory';
import { documentFile } from './eliot/documentFile';
import { documentsCompanies } from './eliot/documentsCompanies';
import { tag } from './eliot/tag';
import { clientInvoice } from './eliot/clientInvoice';
import { expertInvoice } from './eliot/expertInvoice';
import { payments } from './eliot/payments';
import { creditNotes } from './eliot/creditNote';

export const config: ConfigType = {
  login: 'password',
  hash: '4rr0tdosatvzb70almrhxtkbk',
  locale: 'fr',
  name: 'eliot',
  dashboard: false,
  theme: {
    primary: '#49b1bf',
    secondary: '#1b4867',
    tertiary: '#f7a80e',
    info: '#f7a80e',
  },
  defaultCountry: 'fr',
  preferredCountries: ['fr', 'ma', 'ch', 'tn'],
  invoiceUploadedByUser: true,
  resources: [
    expert,
    client,
    user,
    subCategory,
    company,
    purchaseOrder,
    mission,
    invitation,
    candidate,
    candidacy,
    proposal,
    quotation,
    charge,
    milestone,
    contract,
    contractMilestone,
    validationOrder,
    invoice,
    creditNotes,
    recommendation,
    legalInformation,
    document,
    documentFile,
    documentsCompanies,
    cgu,
    match,
    tag,
    expertInvoice,
    clientInvoice,
    payments,
  ],
};

export default config;
